import { createStyles, Divider, Grid, Theme, WithStyles, withStyles } from '@material-ui/core'
import moment from 'moment'
import * as R from 'ramda'
import React from 'react'

import ActivityCredentials from 'src/Forms/FormTemplates/CareerExplorationNonEnrolledItems/ActivityCredentials'
import {
  ActivityOutcome,
  CareerExplorationItems,
  IncentiveEarnedItems,
  IncentiveTypeItems,
  StipendFrequencyItems,
  WageFrequencyItems
} from './../../../services/Model/Outcome'
import { mapYesNoUnknownToBool } from './../../../services/utils'
import ActivityInformation from './../../FormTemplates/CareerExplorationNonEnrolledItems/ActivityInformation'
import EnrollmentInformation from './../../FormTemplates/CareerExplorationNonEnrolledItems/EnrollmentInformation'
import OutcomesFormActions from './../../FormTemplates/OutcomesFormActions/OutcomesFormActions'
import AcademicAwardDetails from './../FormItems/AcademicAwardDetails'
import AcademicCreditDetails from './../FormItems/AcademicDetails'
import { validateForm } from './../formUtils'
import CredentialSection from '../FormItems/CredentialSection/CredentialSection'

interface CENOProps extends WithStyles<typeof styles> {
  onSubmit: (outcomes: ActivityOutcome) => void,
  outcomes: ActivityOutcome
}

interface CENOState {
  localOutcomes: ActivityOutcome
}
const TOP_START_DATE = new Date()
export class CareerExplorationNonEnrolled extends React.Component<CENOProps, CENOState> {
  public readonly state: CENOState = {
    localOutcomes: this.props.outcomes
  }

  formRef: React.RefObject<HTMLFormElement> = React.createRef()

  onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (validateForm(this.formRef)) {
      this.props.onSubmit(this.state.localOutcomes)
    }
  }

  handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target
    console.log(`name1=${name}, value=${value}`)
    const updatedOutcomes = { ...this.state.localOutcomes, [name]: value }

    this.updateLocalOutcomes(updatedOutcomes)
  }

  updateLocalOutcomes = (outcomes: ActivityOutcome) => {
    this.setState({
      localOutcomes: outcomes,
    })
  }

  handleCareerExplorationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target
    const { localOutcomes } = this.state
    const CareerExplorationItem = CareerExplorationItems.find((i) => i.label === value)
    const careerExplorationType = CareerExplorationItem && CareerExplorationItem.value ?
      CareerExplorationItem.value : localOutcomes.careerExplorationType

    const updatedOutcomes = {
      ...localOutcomes,
      careerExplorationType,
    }

    this.updateLocalOutcomes(updatedOutcomes)
  }

  handleDateChange = (prop: string, value: Date | string) => {
    const updatedOutcomes = { ...this.state.localOutcomes, [prop]: moment(value).format("YYYY-MM-DD") }

    this.setState({
      localOutcomes: updatedOutcomes,
    })
  }

  handleWageFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { localOutcomes } = this.state
    const frequencyItem = WageFrequencyItems.find(i => i.label === e.target.value)
    const wageFrequency = frequencyItem && frequencyItem.value ? frequencyItem.value : null
    const updatedOutcomes = {
      ...localOutcomes,
      wageFrequency
    }

    this.updateLocalOutcomes(updatedOutcomes)
  }


  handleIncentiveEarnedChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target
    const { localOutcomes } = this.state
    const incentiveEarnedItem = IncentiveEarnedItems.find((i) => i.label === value)
    const incentiveEarnedProp = incentiveEarnedItem && incentiveEarnedItem.value ?
      incentiveEarnedItem.value : null
    const updatedOutcomes = {
      ...localOutcomes,
      incentiveEarned: incentiveEarnedProp,
      incentiveType: null,
      stipendAmount: null,
      stipendFrequency: null,
      wageAmount: null,
      wageFrequency: null
    }

    this.updateLocalOutcomes(updatedOutcomes)
  }

  handleIncentiveTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target
    const { localOutcomes } = this.state
    const incentiveTypeItem = IncentiveTypeItems.find((i) => i.label === value)
    const incentiveType = incentiveTypeItem && incentiveTypeItem.value ?
      incentiveTypeItem.value : null

    this.updateLocalOutcomes({
      ...localOutcomes,
      incentiveType
    })
  }

  handleEarnedAcademicDegree = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const earnedDegreeOrCredit = mapYesNoUnknownToBool(e.target.value)
    const { localOutcomes } = this.state

    this.updateLocalOutcomes({
      ...localOutcomes,
      earnedDegreeOrCredit,
      creditsEarned: earnedDegreeOrCredit ? localOutcomes.creditsEarned : null,
      academicCredit: earnedDegreeOrCredit ? localOutcomes.academicCredit : null,
    })
  }

  handleStipendFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { localOutcomes } = this.state
    const frequencyItem = StipendFrequencyItems.find(i => i.label === e.target.value)
    const stipendFrequency = frequencyItem && frequencyItem.value ? frequencyItem.value : null
    const updatedOutcomes = {
      ...localOutcomes,
      stipendFrequency
    }

    this.updateLocalOutcomes(updatedOutcomes)
  }

  handleCredentialTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { localOutcomes } = this.state
    const credentialType = e.target.value

    if (credentialType === "None") {
      localOutcomes.credential1 = null
      localOutcomes.credential2 = null
      localOutcomes.credential3 = null
    }

    this.updateLocalOutcomes({
      ...localOutcomes,
      credentialType
    })
  }

  handleDateCredentialAttained = (dateCredentialAttained)=>{
    const { localOutcomes } = this.state
    
    this.updateLocalOutcomes({
      ...localOutcomes,
      dateCredentialAttained
    })
  }

  componentWillReceiveProps(nextProps: CENOProps) {
    if (R.equals(this.props.outcomes, nextProps.outcomes)) return

    this.setState((prevState: CENOState) => ({ ...prevState, localOutcomes: nextProps.outcomes }))
  }

  onCancel = () => {
    this.updateLocalOutcomes(this.props.outcomes)
  }

  onSchoolNamesSelect = (schools: string) => {
    this.setState({
      localOutcomes: {
        ...this.state.localOutcomes,
        schoolNames: schools
      },
    })
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    const { classes } = this.props
    const { localOutcomes } = this.state
    const startDate = localOutcomes ? localOutcomes.startDate : null
    const minEndDate = startDate ? moment(startDate).format('YYYY-MM-DD') : moment(TOP_START_DATE).format('YYYY-MM-DD')

    return (
      <div className={classes.root} data-auto="form-wrapper">
        <Divider variant="middle" style={{ margin: '15px 0' }} />
        <Grid container={true} spacing={8}>
          {
            !R.isEmpty(localOutcomes) && !!localOutcomes &&
            <form onSubmit={this.onFormSubmit} ref={this.formRef} className={classes.form}>
              <EnrollmentInformation
                totalParticipantsEnrolled={localOutcomes.totalParticipantsEnrolled}
                onTotalParticipantsChange={this.handleTextChange}
                schoolNames={localOutcomes.schoolNames}
                onSchoolNameChange={this.onSchoolNamesSelect}
                currentGrade={localOutcomes.currentGrade}
                onCurrentGradeChange={this.handleTextChange}
              />

              <Divider variant="middle" style={{ margin: '15px 0' }} />

              <ActivityInformation
                totalParticipantsEnrolled={localOutcomes.totalParticipantsEnrolled}
                typeOfCareerExploration={localOutcomes.careerExplorationType}
                onTypeOfCareerExplorationChange={this.handleCareerExplorationChange}
                onDateChange={this.handleDateChange}
                startDate={localOutcomes.startDate}
                endDate={localOutcomes.endDate}
                totalParticipantsCompleted={localOutcomes.totalParticipantsCompleted}
                onTotalParticipantsCompletedChange={this.handleTextChange}
                totalHours={localOutcomes.totalHours}
                onTotalHoursChange={this.handleTextChange}
                onFrequencyChange={this.handleWageFrequencyChange}
                handleWageAmountChange={this.handleTextChange}
                incentiveEarned={localOutcomes.incentiveEarned}
                onIncentiveEarnedChange={this.handleIncentiveEarnedChange}
                incentiveType={localOutcomes.incentiveType}
                handleIncentiveTypeChange={this.handleIncentiveTypeChange}
                stipendAmount={localOutcomes.stipendAmount}
                stipendFrequency={localOutcomes.stipendFrequency}
                handleStipendAmountChange={this.handleTextChange}
                handleStipendFrequencyChange={this.handleStipendFrequencyChange}
                wageAmount={localOutcomes.wageAmount}
                wageFrequency={localOutcomes.wageFrequency}
                minEndDate={minEndDate}
              />

              <Divider variant="middle" style={{ margin: '15px 0' }} />
              <Grid>
                <AcademicCreditDetails
                  earnedDegreeOrCredit={localOutcomes.earnedDegreeOrCredit}
                  academicCredit={localOutcomes.academicCredit || ''}
                  creditsEarned={localOutcomes.creditsEarned || ''}
                  handleEarnedDegreeChange={this.handleEarnedAcademicDegree}
                  handleTypeofCreditChange={this.handleTextChange}
                  handleCreditsEarnedChange={this.handleTextChange}
                />

                
                <CredentialSection
                  index={1}
                />
                <CredentialSection
                  index={2}
                />
                
                <AcademicAwardDetails
                  onChange={this.handleTextChange}
                  value={localOutcomes.academicAwardDetail || ''}
                />
              </Grid>
              <Divider variant="middle" style={{ margin: '15px 0' }} />

              <OutcomesFormActions
                onCancel={this.onCancel}
                isSubmitDisabled={R.equals(this.props.outcomes, this.state.localOutcomes)}
              />
            </form>
          }
        </Grid>
      </div>
    )
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    form: {
      width: '100%',
      paddingBottom: '20px',
      maxWidth: '70vw'
    },
    enrollmentInformation: {}
  })

export default withStyles(styles)(CareerExplorationNonEnrolled)
